import { render } from "./EditDelivery.vue?vue&type=template&id=0b0406df&scoped=true"
import script from "./EditDelivery.vue?vue&type=script&lang=ts"
export * from "./EditDelivery.vue?vue&type=script&lang=ts"

import "./EditDelivery.vue?vue&type=style&index=0&id=0b0406df&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0b0406df"

export default script